import { ReactNode } from 'react';
import KubitTooltip from '../KubitTooltip';
import { IconContainer } from './RightSideBarUI';
import { IconName, SvgIcon } from '../Icon';
import { ITooltipOption } from '../KubitTooltip/globalTooltips';
import { IButtonAnalyticsProps } from '../Button/types';

interface IProps extends ITooltipOption, IButtonAnalyticsProps {
  active: boolean;
  onClick: () => void;
  icon: IconName;
  children?: ReactNode;
}

const RightSideBarIcon = ({
  active,
  onClick,
  icon,
  trackAction,
  trackContext,
  children,
  ...rest
}: IProps) => {
  return (
    <KubitTooltip
      placement="left"
      noOpenDelay={true}
      disabled={active}
      {...rest}
    >
      <IconContainer
        type="button"
        $isActive={active}
        onClick={onClick}
        trackAction={trackAction}
        trackContext={trackContext}
      >
        <SvgIcon name={icon} width={24} height={24} customFill="currentColor" />
        {children}
      </IconContainer>
    </KubitTooltip>
  );
};

export default RightSideBarIcon;
